import { DAILY, MONTHLY, WEEKLY, YEARLY } from "constant";
import { ChangeEvent } from "react";
import { Col, Form } from "react-bootstrap";

const RepeatOption = ({
    value,
    onChange,
}: {
    value: string;
    onChange: Function;
}) => {
    return (
        <div className="form-box  mb-3">
            <h5 className="mb-4">Repeat</h5>
            <Form.Row>
                {[DAILY, WEEKLY, MONTHLY, YEARLY].map((item, index) => (
                    <Col sm={2} key={item + index}>
                        <Form.Check
                            name="repeat"
                            id={item}
                            value={item}
                            checked={value === item}
                            custom
                            type="radio"
                            label={
                                <span className="ml-2">
                                    {item.capitalize()}
                                </span>
                            }
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                onChange(e.target.value);
                            }}
                        />
                    </Col>
                ))}
            </Form.Row>
        </div>
    );
};

export default RepeatOption;
